module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="tip-title">Hint:<br>_</div>\n<div class="tip-icon"></div>\n<div class="tip-content"></div>\n<div class="tip-close">Close</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/common/tip/Tip.tpl
// module id = 3188
// module chunks = 0